import Image from 'next/image';
import React from 'react';

import classes from '@nerdwallet/base-styles/classes';
import { Box } from '@nerdwallet/currency/components/Box';
import { Link } from '@nerdwallet/currency/components/Link';
import { Stack } from '@nerdwallet/currency/components/Stack';
import { Text } from '@nerdwallet/currency/components/Text';

import Touchable from '@components/touchable';
import { useAnalytics, SegmentEventViewed } from '@lib/segment';

import styles from './bottom-link.module.scss';
import { BottomLinkItem } from '../constants';

const segmentEventProps = {
  meaningful_engagement_category: 'Credit Score',
  meaningful_engagement_subcategory: 'Credit Tools',
  meaningful_engagement_flag: true,
};

interface Props {
  linkItem: BottomLinkItem;
}

const BottomLink: React.FC<Props> = ({
  linkItem: { cta, iconAlt, iconUrl, segmentEventPrefix, title, href, target },
}) => {
  const { segmentTrack } = useAnalytics();

  const onTileClicked = () => {
    segmentTrack(`${segmentEventPrefix} Tile Clicked`, segmentEventProps);
  };

  return (
    <Box
      border="1"
      borderColor="neutral-lighter"
      borderRadius="1"
      className={styles.hover}
      height="100"
      width="100"
    >
      <SegmentEventViewed eventName={`${segmentEventPrefix} Tile Viewed`}>
        <Touchable
          className={classes('display-block', 'width-100')}
          href={href}
          onClick={onTileClicked}
          rel={target === '_blank' ? 'noreferrer nofollow' : undefined}
          target={target}
        >
          <Box
            display="flex"
            height="100"
            justifyContent="space-between"
            padding="3"
          >
            <Stack spacing="2">
              <Text>{title}</Text>
              <Link>{cta}</Link>
            </Stack>
            <Box className={styles.bottomCtaIcon} marginLeft="3">
              <Image
                alt={iconAlt}
                height={64}
                width={64}
                role="presentation"
                src={iconUrl}
                loading="lazy"
              />
            </Box>
          </Box>
        </Touchable>
      </SegmentEventViewed>
    </Box>
  );
};

export default BottomLink;
